import type { CSSProperties } from 'vue'

interface TransformOptions {
  multiplierX: number
  multiplierY: number
  rotateMultiplier: number
}

/**
 * A composable that returns computed CSS properties based on the window scroll y position.
 * @param options
 * @returns Computed CSSProperties with transform styles.
 */
export function useScrollTransformedStyle(options: TransformOptions) {
  const { y } = useWindowScroll()

  const transformedStyles = computed<CSSProperties>(() => {
    const translateX = y.value * options.multiplierX
    const translateY = y.value * options.multiplierY
    const rotate = y.value * options.rotateMultiplier
    return {
      transformOrigin: 'center',
      transform: `translate(${translateX}px, ${translateY}px) rotate(${rotate}deg)`,
    }
  })

  return transformedStyles
}
